import { isAxiosError } from "axios";
import { DocumentDto } from "../types";
import { assetDetailsGw as gw } from "./axios/assetDetailsGw";

export namespace DocumentsClient {
  export const getDocuments = async (): Promise<DocumentDto[]> => {
    try {
      const { data } = await gw.get<{ data: DocumentDto[] }>("/documents", {});
      return data.data;
    } catch (error) {
      const status = isAxiosError(error) ? error.response?.status : undefined;
      if (status === 404) return [];
      else throw error;
    }
  };

  export const getDocumentUrl = async (
    document: DocumentDto,
  ): Promise<string> => {
    const { tokenId, issuerId } = document;
    try {
      const { data } = await gw.get<{ url: string }>(
        `/documents/${document.id}/download`,
        {
          params: {
            tokenId,
            issuerId,
          },
        },
      );
      return data.url;
    } catch (error) {
      return undefined;
    }
  };

  export const getStatementUrl = async (
    document: DocumentDto,
  ): Promise<string> => {
    const { tokenId, issuerId } = document;
    try {
      const { data } = await gw.get<{ url: string }>(
        `/documents/${document.id}/download/statement`,
        {
          params: {
            tokenId,
            issuerId,
          },
        },
      );
      return data.url;
    } catch (error) {
      return undefined;
    }
  };
}
